import { render, staticRenderFns } from "./ed-presentation-mode-teacher.component.vue?vue&type=template&id=6cd9f530&scoped=true&"
import script from "./ed-presentation-mode-teacher.component.ts?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-teacher.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-teacher.component.scss?vue&type=style&index=0&id=6cd9f530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd9f530",
  null
  
)

export default component.exports